"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const contentVersionLogQueryHelper_1 = require("../../common/contentVersionLogQueryHelper");
function getPaginatedContentVersionLogs(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const elasticsearchResult = yield contentVersionLogQueryHelper_1.getContentVersionLogsUsingQuery(input);
        return elasticsearchResult;
    });
}
exports.getPaginatedContentVersionLogs = getPaginatedContentVersionLogs;
//# sourceMappingURL=index.js.map